import { AxiosInstance, AxiosPromise } from 'axios';
import ActionNames from './actionNames';

export interface IOssaRequests {
  [ActionNames.NEWS]: (params?: {
    page?: number;
    date_start?: string;
    date_end?: string;
    limit?: number;
  }) => AxiosPromise<any>;
}

class OssaService {
  private _client: AxiosInstance;
  public requests: IOssaRequests = {} as IOssaRequests;

  public constructor(client: AxiosInstance) {
    this._client = client;
    this.init();
  }

  private init = (): void => {
    this.requests[ActionNames.NEWS] = (params?: {
      page?: number;
      date_start?: string;
      date_end?: string;
      limit?: number;
    }): AxiosPromise => {
      const { page = 1, date_start, date_end, limit = 10 } = params || {};

      let url = `/api/v1/news/?page=${page}&limit=${limit}`;
      if (date_start) url += `&date_start=${date_start}`;
      if (date_end) url += `&date_end=${date_end}`;

      return this._client.get(url);
    };
  };
}

export default OssaService;
